export const REQUEST_API_CALLS_DETAILS = 'REQUEST_API_CALLS_DETAILS'
export const RECEIVE_API_CALLS_DETAILS = 'RECEIVE_API_CALLS_DETAILS'
export const REQUEST_API_CALLS_SUMMARY = 'REQUEST_API_CALLS_SUMMARY'
export const RECEIVE_API_CALLS_SUMMARY = 'RECEIVE_API_CALLS_SUMMARY'
export const SERVICE_ERROR = 'SERVICE_ERROR'



/** WEBPACK FOOTER **
 ** ./src/constants/apiCallsConstants.js
 **/